export default {
    getPhysios(axios) {
        return axios({
            url: `physios`,
            method: 'GET'
        })
    },
    get(id, axios) {
        return axios({
            url: `physios/${id}/view`,
            method: 'GET'
        })
    },
    add(patientData, axios) {
        return axios({
            url: `physios/add`,
            method: 'POST',
            data: patientData
        })
    },
    update(id, patientData, axios) {
        return axios({
            url: `physios/${id}/update`,
            method: 'POST',
            data: patientData
        })
    },
    delete(id, axios) {
        return axios({
            url: `physios/${id}/delete`,
            method: 'POST'
        })
    }
}
